module.exports = __webpack_public_path__ + "static/media/emissor-b-1.513ee392.png";